( function ( _s ) {
	/**
	 * Observes the entire document body for changes.
	 * When a new element with the class "card" is added or an existing one is modified,
	 * the `cardInit()` _s plugin is applied to it.
	 */
	const observeCards = () => {
		const observer = new MutationObserver( mutations => {
			mutations.forEach( mutation => {
				if ( mutation.type === 'childList' ) {
					mutation.addedNodes.forEach( node => {
						if ( node.nodeType === Node.ELEMENT_NODE ) {
							//Check/wait for Shave.js to be added first because cards depend on it
							_s( window ).trigger( 'fr:initialize-shave', {
								callback: () => {
									node.querySelectorAll( '.card' ).forEach( cardElement => {
										_s( cardElement ).cardInit();
									} );
								},
							} );
						}
					} );
				}
			} );
		} );

		// Observe the entire document body for changes
		observer.observe( document.body, { childList: true, subtree: true } );
	};

	// Call the function to start observing
	observeCards();
} )( window._s );
